import { render, staticRenderFns } from "./KnowledgeBaseEditDialog.vue?vue&type=template&id=7cd7f048"
import script from "./KnowledgeBaseEditDialog.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports